import { render, staticRenderFns } from "./FolderItem.vue?vue&type=template&id=0852a0ac&scoped=true"
import script from "./FolderItem.vue?vue&type=script&lang=js"
export * from "./FolderItem.vue?vue&type=script&lang=js"
import style0 from "./FolderItem.vue?vue&type=style&index=0&id=0852a0ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0852a0ac",
  null
  
)

export default component.exports